module.exports = __webpack_public_path__ + "static/media/send.d9e3e383.svg";